<h2 mat-dialog-title>JSON Viewer</h2>
<mat-dialog-content>
  <div class="json-viewer-container">
  <ngx-json-viewer [json]="jsonData" [depth]="2"></ngx-json-viewer>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onClose()">Close</button>
</mat-dialog-actions>